import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { modalPrimaryButtonStyle } from '../styles/buttonStyles'

const ReceiptInfoModal = ({
  open,
  onClose,
  supportedBrands = []
}) => {
  const { t, i18n } = useTranslation()

  const [hoverBtn, setHoverBtn] = useState(null)
  const [pressedBtn, setPressedBtn] = useState(null)

  const NOTICE_PREFIX = '__NOTICE__:'

  const currentLang =
    String(i18n.language || 'sk').split('-')[0] || 'sk'

  const brandNames = supportedBrands
    .map((brand) =>
      typeof brand === 'string'
        ? brand
        : brand?.name || ''
    )
    .filter(Boolean)

  const noticeMessage =
    brandNames
      .find((brand) =>
        brand.startsWith(`${NOTICE_PREFIX}${currentLang}:`)
      )
      ?.replace(`${NOTICE_PREFIX}${currentLang}:`, '')
      .trim()
    ||
    brandNames
      .find((brand) =>
        brand.startsWith(`${NOTICE_PREFIX}sk:`)
      )
      ?.replace(`${NOTICE_PREFIX}sk:`, '')
      .trim()
    || ''

  const visibleBrands = brandNames.filter(
    (brand) => !brand.startsWith(NOTICE_PREFIX)
  )

  useEffect(() => {
    if (!open) return

    const handleKeyDown = (e) => {
      if (e.key !== 'Escape') return

      e.preventDefault()
      e.stopPropagation()
      onClose()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 5000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#122629',
          padding: 20,
          border: '2px solid #107c6b',
          borderRadius: 12,
          boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
          width: 'clamp(320px, 32vw, 460px)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            marginBottom: 24
          }}
        >
          <p
            style={{
              fontSize: 20,
              margin: '0 0 14px 0',
              color: '#d9ffe4',
              fontWeight: 700
            }}
          >
            {t('OCR_RECEIPT_INFO_TITLE')}
          </p>

          <p
            style={{
              fontSize: 15,
              lineHeight: 1.5,
              margin: '0 0 18px 0',
              color: 'rgba(217,255,228,0.85)'
            }}
          >
            {t('OCR_RECEIPT_INFO_TEXT')}
          </p>

          <div
            style={{
              fontSize: 14,
              lineHeight: 1.6,
              color: '#b9f3d3',
              background: 'rgba(16,124,107,0.12)',
              border: '1px solid rgba(16,124,107,0.4)',
              borderRadius: 8,
              padding: 12,
              width: 'fit-content',
              maxWidth: '100%',
              margin: '0 auto'
            }}
          >
            {visibleBrands.length > 0 ? (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(5, 1fr)',
                  gap: 8,
                  textAlign: 'center'
                }}
              >
                {visibleBrands.map((brand, index) => (
                  <div key={index}>
                    {brand}
                  </div>
                ))}
              </div>
            ) : (
              t('OCR_RECEIPT_SUPPORTED_EMPTY')
            )}
          </div>

          {noticeMessage && (
            <div
              style={{
                marginTop: 12,
                fontSize: 14,
                lineHeight: 1.5,
                color: '#b9f3d3',
                textAlign: 'center'
              }}
            >
              {noticeMessage}
            </div>
          )}
        </div>

        <button
          style={modalPrimaryButtonStyle(
            pressedBtn,
            'close',
            hoverBtn === 'close'
          )}
          onMouseEnter={() => setHoverBtn('close')}
          onMouseLeave={() => {
            setHoverBtn(null)
            setPressedBtn(null)
          }}
          onMouseDown={() => setPressedBtn('close')}
          onMouseUp={() => setPressedBtn(null)}
          onClick={onClose}
        >
          {t('CLOSE')}
        </button>
      </div>
    </div>
  )
}

export default ReceiptInfoModal